import { RouteComponentProps } from '@reach/router';
import { NOT_FOUND_PAGE } from 'appConstants';
import ErrorMessage from 'components/errorMessage/ErrorMessage';

import Page from 'components/shared/Page';
import { useSelector } from 'react-redux';
import { selectSignedIn } from 'reducers/auth';

type Props = RouteComponentProps;

const NotFound: React.FC<Props> = () => {
  const isSignedIn = useSelector(selectSignedIn);
  return isSignedIn ? (
    <Page isNotFound />
  ) : (
    <Page isPublic isNotFound>
      <ErrorMessage message={NOT_FOUND_PAGE} />
    </Page>
  );
};

export default NotFound;
